import { ObjectMapper } from "json-object-mapper";
import { WorkforceplanEventType } from "services/enums/WorkforceplanEventType.enum";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class EventFilterModel {
	eventType: WorkforceplanEventType;
	isChecked: boolean;
}

export class WorkforcePlanEventModel extends Model {
	start: string = "";
	end: string = "";
	description: string = "";
	eventType: any = WorkforceplanEventType.None.id;

	get eventTypeData(): WorkforceplanEventType {
		return WorkforceplanEventType.getBy(this.eventType);
	}

	get eventTypeLabel() {
		return this.eventType.label;
	}
}

export class WorkforcePlanCalendarModel extends Model implements IModel<WorkforcePlanCalendarModel> {
	id: string = "";
	name: string = "";
	registration: string = "";
	shortProfileImagePath: string = "";
	jobTitleId: string = "";
	jobTitleName: string = "";
	jobTitleGroupId: string = "";
	jobTitleGroupName: string = "";
	workScaleGroup: string = "";
	events: WorkforcePlanEventModel[] = [];
	days: { date: string, events: WorkforcePlanEventModel[] }[] = [];

	static create(input: any): WorkforcePlanCalendarModel {
		return ObjectMapper.deserialize<WorkforcePlanCalendarModel>(WorkforcePlanCalendarModel, input);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}
